import { Row, Col, Modal, Form, Input, Select, DatePicker } from "antd";
import React, { useState, useEffect } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";
import lang from "../../helper/lang";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
import moment from "moment";

const { Option } = Select;
const { TextArea } = Input;

const MaintenanceForm = ({ show, hide, data, refresh }) => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const [loading, setLoading] = useState(false);

  // SUBMIT
  const onSubmit = (values) => {
    setLoading(true);

    const payload = {
      isEnabled: values.isEnabled,
      message: values.message,
      startAt: values.startAt ? values.startAt.toISOString() : undefined,
      endAt: values.endAt ? values.endAt.toISOString() : undefined,
    };

    request({
      url: apiPath.addMaintenanace,
      method: "PUT",
      data: payload,
      onSuccess: (res) => {
        setLoading(false);
        if (res.status) {
          ShowToast(res.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(res.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        setLoading(false);
        ShowToast(error.response?.data?.message, Severty.ERROR);
      },
    });
  };

  // PREFILL DATA
  useEffect(() => {
    if (!data) return;

    form.setFieldsValue({
      isEnabled: data.isEnabled,
      message: data.message,
      startAt: data.startAt ? moment(data.startAt) : null,
      endAt: data.endAt ? moment(data.endAt) : null,
    });
  }, [data]);

  return (
    <Modal
      width={550}
      open={show}
      title="Maintenance Mode Settings"
      okText="Save"
      cancelText={
        <>
          <CloseOutlined style={{ marginRight: 8 }} />
          {lang("Cancel")}
        </>
      }
      onCancel={hide}
      okButtonProps={{
        form: "maintenance-form",
        htmlType: "submit",
        loading,
        icon: <CheckOutlined />,
      }}
    >
      <Form
        id="maintenance-form"
        form={form}
        onFinish={onSubmit}
        layout="vertical"
      >
        <Row gutter={[16, 16]}>
          {/* Enable / Disable */}
          <Col span={24}>
            <Form.Item
              label="Maintenance Status"
              name="isEnabled"
              rules={[{ required: true, message: "Select status" }]}
            >
              <Select placeholder="Select status">
                <Option value={true}>Enabled</Option>
                <Option value={false}>Disabled</Option>
              </Select>
            </Form.Item>
          </Col>

          {/* Message */}
          <Col span={24}>
            <Form.Item
              label="Maintenance Message"
              name="message"
              rules={[
                {
                  required: true,
                  message: "Enter maintenance message",
                },
              ]}
            >
              <TextArea
                rows={3}
                placeholder="System is under maintenance. Please try again later."
              />
            </Form.Item>
          </Col>

          {/* Start Time */}
          <Col span={12}>
            <Form.Item label="Start Time" name="startAt">
              <DatePicker
                showTime
                style={{ width: "100%" }}
                placeholder="Optional"
              />
            </Form.Item>
          </Col>

          {/* End Time */}
          <Col span={12}>
            <Form.Item label="End Time" name="endAt">
              <DatePicker
                showTime
                style={{ width: "100%" }}
                placeholder="Optional"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default MaintenanceForm;
